import type { ReactNode } from 'react'
import { Fragment } from 'react'
import { injectIntl } from 'react-intl'
import { type InjectedIntlProps } from '../../intl/intl.types'
import { _useDocumentTitleString } from '../../utils/document/document.hooks'

interface Props {
  children?: ReactNode
  title?: string
  titleId?: string
}

const DocumentTitle = injectIntl<'intl', Props & InjectedIntlProps>(
  ({ title, titleId = 'default.title', intl, children }) => {
    const titleString = title || intl.formatMessage({ id: titleId })

    _useDocumentTitleString(titleString)

    return <Fragment>{children}</Fragment>
  }
)

export default DocumentTitle
